import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const DashboardService = {
  async getClubDashboard(clubId) {
    if (!clubId) {
      return { status: 400, data: null, message: "clubId ausente" };
    }
    return safeRequest(
      apiClient.get(`/clubs/${clubId}/dashboard`).then((response) => response.data),
    );
  },

  async getGlobalAdminDashboard() {
    return safeRequest(
      apiClient.get("/dashboard/admin").then((response) => response.data),
    );
  },
};
